module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_1.875a8db5.png";